module.exports = __webpack_public_path__ + "img/u13.59ac721d.png";